// Base interfaces
export type { ObjOptions, InstanceObjOptions } from './base.js'

// Organizational objects
export {
  OrganizationObj,
  isOrganizationObj,
  GroupObj,
  isGroupObj,
  PersonObj,
  isPersonObj,
  ServiceAccountObj,
  isServiceAccountObj
} from './organizational.js'
export type { PersonObjOptions, ServiceAccountObjOptions } from './organizational.js'

// Content objects
export {
  ItemObj,
  isItemObj,
  FolderObj,
  isFolderObj,
  PageObj,
  isPageObj
} from './content.js'
export type { PageObjOptions } from './content.js'

// Diagram objects
export { DiagramObj, isDiagramObj } from './diagram.js'
export type { DiagramObjOptions } from './diagram.js'

// Security objects
export {
  SecurityPolicyObj,
  isSecurityPolicyObj,
  PolicyRuleObj,
  isPolicyRuleObj
} from './security.js'
export type { PolicyRuleObjOptions } from './security.js'

// Runtime objects
export {
  ProcessObj,
  isProcessObj,
  ProcessInstanceObj,
  isProcessInstanceObj,
  FunctionObj,
  isFunctionObj,
  FunctionInstanceObj,
  isFunctionInstanceObj,
  ServiceObj,
  isServiceObj
} from './runtime.js'
export type {
  ProcessObjOptions,
  ProcessInstanceObjOptions,
  FunctionObjOptions,
  FunctionInstanceObjOptions,
  ServiceObjOptions
} from './runtime.js'

// Event objects
export {
  EventObj,
  isEventObj,
  EventInstanceObj,
  isEventInstanceObj,
  ErrorEventObj,
  isErrorEventObj,
  ErrorEventInstanceObj,
  isErrorEventInstanceObj
} from './events.js'
export type { ErrorEventInstanceObjOptions, EventObjOptions } from './events.js'

// System objects
export { SystemObj, isSystemObj } from './system.js'

// Types and type guards
export type { AnyObj } from './types.js'
export { isObjOfType } from './types.js'

// Factory functions
export { createObj, registerTypeOfClass, typeOfToClassMap } from './factory.js'
